/**
 * Recommendation funnel + cards quality-signal tracking
 * (H-2026-04-25-002 — artemis contract).
 *
 * Classic-script mirror of packages/web-kit/src/tracking-funnel.js (the
 * CANONICAL ESM copy — creator-hub and mobile import it since 2026-07-07).
 * This is the ONE remaining copy, kept because Liquid loads plain script
 * tags, not ESM bundles. Any wire-format change lands in web-kit FIRST,
 * then here. Wire-format authority:
 *   .kiro/governance/handoffs/H-2026-04-25-002-...md §A
 *
 * Usage in a Liquid section:
 *
 *   {{ 'tracking-funnel.js' | asset_url | script_tag }}
 *   <script>
 *     window.MMSFunnel.observe({
 *       selector: '.rec-card',
 *       scenario: 'pdp_related',
 *       pageType: 'pdp',
 *     })
 *     // on click handler:
 *     window.MMSFunnel.click(card.dataset.recId)
 *   </script>
 *
 * Errors are silent. fetch keepalive: true so requests survive
 * navigation away.
 */
;(function () {
  if (window.MMSFunnel) return // idempotent

  // ADR-006: rec-api.mamamiya.store is DEAD — the recommendation surface
  // lives on mms-platform-api (admin-api host) since the ADR-002 absorb.
  var REC_API = 'https://admin-api.mamamiya.store'

  function mintRecId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID()
    }
    return 'rec_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)
  }

  function deviceType() {
    return /Mobi/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
  }

  function silentPost(url, body) {
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
      }).catch(function () {})
    } catch (_e) {
      // ignore
    }
  }

  function getSessionId() {
    try {
      var id = localStorage.getItem('mms_session_id')
      if (!id) {
        id = 'sho_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)
        localStorage.setItem('mms_session_id', id)
      }
      return id
    } catch (_e) {
      return undefined
    }
  }

  function impression(opts) {
    var id = opts.recommendationId || mintRecId()
    silentPost(REC_API + '/api/recommendation/track/impression', {
      recommendationId: id,
      scenario: opts.scenario,
      productId: opts.productId,
      userId: opts.userId || null,
      sessionId: opts.sessionId || getSessionId(),
      position: opts.position,
      pageType: opts.pageType,
      deviceType: deviceType(),
      referrer: document.referrer || null,
    })
    return id
  }

  function click(recommendationId) {
    if (!recommendationId) return
    silentPost(REC_API + '/api/recommendation/track/click', { recommendationId: recommendationId })
  }

  function cart(recommendationId) {
    if (!recommendationId) return
    silentPost(REC_API + '/api/recommendation/track/cart', { recommendationId: recommendationId })
  }

  function purchase(recommendationId, revenue) {
    if (!recommendationId) return
    silentPost(REC_API + '/api/recommendation/track/purchase', {
      recommendationId: recommendationId,
      revenue: revenue,
    })
  }

  /**
   * Wire IntersectionObserver impression + automatic recommendationId
   * stamping for elements matching `selector`. Each element must carry
   * data-product-id and data-position.
   * Returns the IntersectionObserver so callers can disconnect on tear-down.
   */
  function observe(opts) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return
          var el = e.target
          if (el.dataset.recId) return
          var pid = Number(el.dataset.productId)
          if (!pid) return
          var id = impression({
            productId: pid,
            scenario: opts.scenario,
            position: Number(el.dataset.position || 0),
            pageType: opts.pageType,
            sessionId: opts.sessionId,
            userId: opts.userId,
          })
          el.dataset.recId = id
          io.unobserve(el)
        })
      },
      { threshold: 0.5 }
    )
    var root = opts.root || document
    root.querySelectorAll(opts.selector).forEach(function (el) {
      io.observe(el)
    })
    return io
  }

  window.MMSFunnel = {
    impression: impression,
    click: click,
    cart: cart,
    purchase: purchase,
    observe: observe,
    mintRecId: mintRecId,
  }
})()
